import type { FeatureAccessRule, UiFeaturePolicy } from '../types/uiAccessPolicy';

export type FeatureAccessContextInput = {
  configId?: string | null;
  userId?: number | null;
  userRole?: string | null;
};

function ruleFor(policy: UiFeaturePolicy, featureKey: string): FeatureAccessRule | null {
  return policy.features[featureKey] ?? null;
}

export function canAccessFeature(
  policy: UiFeaturePolicy,
  featureKey: string,
  ctx: FeatureAccessContextInput,
): boolean {
  const rule = ruleFor(policy, featureKey);
  if (!rule) return true;

  const configId = ctx.configId ?? null;
  const userId = ctx.userId ?? null;
  const userRole = (ctx.userRole ?? '').toLowerCase();

  if (configId && (rule.deniedConfigIds ?? []).includes(configId)) return false;

  if ((rule.allowedConfigIds ?? []).length > 0) {
    if (configId && (rule.allowedConfigIds ?? []).includes(configId)) return true;
    return false;
  }

  const hasUserConstraints = (rule.allowedUserIds?.length ?? 0) > 0 || (rule.allowedRoles?.length ?? 0) > 0;
  if (hasUserConstraints) {
    const userOk = userId != null && (rule.allowedUserIds ?? []).includes(userId);
    const roleOk = !!userRole && (rule.allowedRoles ?? []).map((x) => x.toLowerCase()).includes(userRole);
    if (!(userOk || roleOk)) return false;
  }

  return !!rule.enabledByDefault;
}
